import React,{ Component } from "react";
import { showLoader, removeLoader, showToast, TOAST_TYPE, DKLabel, DKButton, DKInput } from 'deskera-ui-library';
import Popup from "../common/Popup";
import { AccountTypes, AccountTypesUS, employeeDetailDefaultValues, PaymentMethods, Payment_Details, SGPaymentMethods, USPaymentMethods, CONFIG_SECTION } from "../add-employee/steps/Employee";
import { ACCOUNT_NUMBER, COLUMN_CODES, CONSTANTS, COUNTRY_CODE, ROUTING_REGEX } from "../../constants/Constant";
import { IFSC_PATTERN, ROUTING_NUMBER_REGEX, UPI_PATTERN } from "../../constants/RegexConstants";
import Utility, { deepClone } from "../../utility/Utility";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import TenantManager from "../../managers/TenantManager";
import { getTenantCountryCode, isMYCompliance, isUSCompliance, scrollToError } from "../../managers/common/CommonUtil";
import DataGridUtility from "../../utility/DataGridUtility";
import Table from "../../services/table";
import i18next from "i18next";
import EmployeeListService from "../../services/EmployeeListService";
import { COUNTRY } from "../../constants/CountryConstant";
import { connect } from "react-redux";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import EmployeeConfigService from "../../services/EmployeeConfigService";
class PaymentMethod extends Component {
  defaultValues;
  constructor(props) {
    super(props)
    this.paymentFormFields = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.EMPLOYEE_PAYMENT_DETAILS)
    this.country = TenantService.get(TENANT.COUNTRY_CODE)
    this.defaultValues = deepClone(employeeDetailDefaultValues)
    this.paymentInitials = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.EMPLOYEE_PAYMENT_DETAILS)
    this.detailsInitials = EmployeeConfigService.getDefaultFieldsBySection(CONFIG_SECTION.EMPLOYEE_DETAILS)
    this.isUSCountry = isUSCompliance();
    this.isAdmin = TenantService.get(TENANT.IS_ADMIN);
    this.isInviteUserEnabled = this.isAdmin && !this.props.isEdit && this.isUSCountry
    this.updateDefaultValues();
    this.updatePaymentInitials()
    this.buildForm();
    this.state = {
        tenatBankDetails:{}
    }
  }

  componentDidMount() {
      this.setState({
        tenatBankDetails: this.props.tenatBankDetails
      })
  }

  updateDefaultValues() {
    if(this.props.data) {

      let accountType = this.country == COUNTRY_CODE.US ? AccountTypesUS :  AccountTypes
      this.defaultValues['paymentMethod'] = this.props.data.paymentMethod? PaymentMethods.find(pm=>pm.id==this.props.data.paymentMethod):"" ;
      this.defaultValues['accountType'] = this.props.data.accountType? accountType.find(at=>at.id==this.props.data.accountType):"" ;
      this.defaultValues['upiId'] = this.props.data.upi;
      this.defaultValues['accountNumber'] = this.props.data.accountNumber;
      this.defaultValues['routingNumber'] = this.props.data.routingNumber;
      this.defaultValues['ifsc'] = this.props.data.ifsc;
      this.defaultValues["bankId"] = this.props.data?.bankId;
      let bankAccounts = this.props.tenatBankDetails?.banksDetails ? EmployeeListService.getBankAccounts(this.props.tenatBankDetails) : [];
      this.defaultValues["bank"]= EmployeeListService.getValueObjectFromDropdown(this.props.data?.bank,bankAccounts, "key");
      this.updateColumConfigForPaymentMethod(this.defaultValues['paymentMethod'],this.isInviteUserEnabled);
    }
  }
  close(valid) {
    if(this.props.onClose) {
      this.props.onClose(valid)
    }
    
  }
  onChange(value, index, object, fieldName) {
    if (value && value === " ") {
      value = value.trim();
    }
    if (Payment_Details.some((x) => x === object.id)) {
      let columnConfig = deepClone(this.paymentFormFields);
      if (object.id === "paymentMethod") {
        this.defaultValues[object.id] = value;
        this.updateColumConfigForPaymentMethod(value);
      } else if (Utility.isEmpty(value) && object.required) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = `${i18next.t("ENTER_VALID")} ${object.name}`;
        this.defaultValues[object.id] = value;
        this.paymentFormFields = columnConfig;
      } else {
        switch (object.id) {
          case COLUMN_CODES.IFSC_CODE:
            const regexIFSC = new RegExp(IFSC_PATTERN);
            columnConfig[index].hasError = !regexIFSC.test(value);
            if (columnConfig[index].hasError) {
              columnConfig[index].errMsg = CONSTANTS.INVALID_IFSC;
            } else {
              columnConfig[index].errMsg = `${i18next.t("ENTER_VALID")} ${object.name}`;
            }
            break;
          case COLUMN_CODES.ACCOUNT_NUMBER:
            let bank = (this.defaultValues.bank && this.defaultValues.bank.key) ?  this.defaultValues.bank.key : this.defaultValues.bank
            this.checkForAccountNumberIsValid(columnConfig, index, this.country, value, bank, object)
            break;
          case COLUMN_CODES.UPI_ID:
            const regexUPI = new RegExp(UPI_PATTERN);
            const upiRegexValue = !regexUPI.test(value);
            columnConfig[index].hasError = !regexUPI.test(value);
            if (!Utility.isEmpty(value) && upiRegexValue) {
              columnConfig[index].hasError = upiRegexValue;
              columnConfig[index].errMsg = CONSTANTS.INVALID_UPI;
            } else {
              columnConfig[index].hasError = false;
              columnConfig[index].errMsg = `${i18next.t("ENTER_VALID")} ${object.name}`;
            }
            break;
          case COLUMN_CODES.ROUTING_NUMBER:
            let bankKey = isMYCompliance()? this.defaultValues['bank'].key:null
            this.checkRoutingNumberIsValid(columnConfig, index, this.country, value,bankKey , object);
            break;
            case COLUMN_CODES.BANK:
                if(value.key) {
                  columnConfig[index].hasError = false;
                  columnConfig[index].errMsg = `Enter a valid ${object.name}`;
                  let routingNoIndex = columnConfig.findIndex(col=>col.columnCode=='routingNumber')
                  let routingObj = columnConfig[routingNoIndex]
                  this.checkRoutingNumberIsValid(columnConfig, routingNoIndex, this.country, this.defaultValues['routingNumber'], value.key, routingObj);
                  
                  let accountNoIndex = columnConfig.findIndex(col=>col.columnCode=='accountNumber')
                  let accountObj = columnConfig[accountNoIndex]
                  this.checkForAccountNumberIsValid(columnConfig,accountNoIndex,this.country, this.defaultValues['accountNumber'],value.key,accountObj)
                }
                break;
          default:
            columnConfig[index].hasError = false;
        }
      }
      this.defaultValues[object.id] = value;
      this.paymentFormFields = columnConfig;
      this.setState({
        ...this.state
      })
    }
  }

  checkRoutingNumberIsValid = (columnConfig, index, country, value, bankKey, object) => {
    let regexStr = ROUTING_REGEX[country]?.regex
    if (isMYCompliance() && ROUTING_NUMBER_REGEX[country] && ROUTING_NUMBER_REGEX[country][bankKey]) {
      regexStr = ROUTING_NUMBER_REGEX[country][bankKey].regex 
      columnConfig[index].errMsg = `${object.name} should be ${ROUTING_NUMBER_REGEX[country][bankKey].errorMsg}` 
    }
    const regex = new RegExp(regexStr);
    const routingRegexValue = !regex.test(value);
    if (!Utility.isEmpty(value) && routingRegexValue) {
      columnConfig[index].hasError = routingRegexValue;
      columnConfig[index].errMsg = ROUTING_REGEX[country]?.error || columnConfig[index].errMsg;
    } else {
      columnConfig[index].hasError = false;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
    }
  }

  checkForAccountNumberIsValid = (columnConfig,index,country,value,bankKey,object) => {
    if (columnConfig[index].required && !Utility.isEmpty(value)) {
      let validationConfig = isMYCompliance() ? ACCOUNT_NUMBER[country][bankKey]: ACCOUNT_NUMBER[country];
      if (validationConfig?.isRegex) {
        const regexAccountNumber = new RegExp(validationConfig.regexPattern);
        const accountNumberRegexValue = !regexAccountNumber.test(value);
        if (accountNumberRegexValue) {
          columnConfig[index].hasError = true;
          columnConfig[index].errMsg = `Enter a valid ${object.name}`;
        }
      } else if (validationConfig?.isMin && value.length < validationConfig?.minValue) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = !Utility.isEmpty(
          validationConfig?.minError
        ) ? validationConfig.minError : `Enter a valid ${object.name}`;
      } else if (validationConfig?.isMax && value.length > validationConfig?.maxValue) {
        columnConfig[index].hasError = true;
        columnConfig[index].errMsg = !Utility.isEmpty(
          validationConfig?.maxError
        )
          ? validationConfig.maxError
          : `Enter a valid ${object.name}`;
      } else {
        columnConfig[index].hasError = false;
        columnConfig[index].errMsg = `Enter a valid ${object.name}`;
      }
    } else if(columnConfig[index].required && Utility.isEmpty(value)) {
      columnConfig[index].hasError = true;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
    } else {
      columnConfig[index].hasError = false;
      columnConfig[index].errMsg = `Enter a valid ${object.name}`;
     }
  }

  updatePaymentInitials() {
    let tenantData = TenantService.getData();
    this.country = (tenantData[TENANT.COUNTRY_CODE]);
    const { tenant } = TenantManager.getPeopleTenantData();
    switch (tenantData[TENANT.COUNTRY_CODE]) {
      case COUNTRY_CODE.US:
        let paymentDetails = this.paymentInitials;

        let paymentMethodInd = paymentDetails.findIndex(
          (res) => res.columnCode == "paymentMethod"
        );
        paymentDetails[paymentMethodInd].options = USPaymentMethods;

        let accountTypeInd = paymentDetails.findIndex(
          (res) => res.id == "accountType"
        );
        paymentDetails[accountTypeInd].options = AccountTypesUS;

        let ifscCodeInd = paymentDetails.findIndex((res) => res.id == "ifsc");
        paymentDetails[ifscCodeInd].uiVisible = false;
        paymentDetails[ifscCodeInd].required = false;

        let routingNumberInd = paymentDetails.findIndex(
          (res) => res.id == "routingNumber"
        );
        paymentDetails[routingNumberInd].name = i18next.t("ROUTING_NUMBER");
        paymentDetails[routingNumberInd].required = true;
        paymentDetails[
          routingNumberInd
        ].errMsg = `${paymentDetails[routingNumberInd].name} ${i18next.t("IS_REQ")}`;
        this.paymentInitials = (paymentDetails);
        break;
      case COUNTRY_CODE.SG:
        // let paymentDetails = this.paymentInitials;
        let paymentDetailsSG = this.paymentInitials;
        const bankAccounts = EmployeeListService.getBankAccounts(this.props.tenatBankDetails);
        const alteredOptionsSG = [
          {columnCode: "paymentMethod", options: SGPaymentMethods, defaultOptions: SGPaymentMethods },
          {columnCode: "bank", options: bankAccounts, defaultOptions: bankAccounts},
          {columnCode: "ifsc", uiVisible: false, required : false},
          {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
          {columnCode: "accountType", uiVisible: false, required : false},
          { columnCode: "accountNumber", name : "Account Number" }
        ];
        paymentDetailsSG = EmployeeListService.getAlteredConfigDetails(paymentDetailsSG, alteredOptionsSG, false, {}, {});
        this.paymentInitials = (paymentDetailsSG);
        break;
        // setPaymentInitials(paymentDetailsSG);
      case COUNTRY_CODE.MY:
        let paymentDetailsMY = this.paymentInitials;
        const bankAccountsMY = EmployeeListService.getBankAccounts(this.props.tenatBankDetails);
        const alteredOptionsMY = [
          { columnCode: "paymentMethod", options: USPaymentMethods, defaultOptions: USPaymentMethods },
          {columnCode: "bank", options: bankAccountsMY, defaultOptions: bankAccountsMY},
          {columnCode: "ifsc", uiVisible: false, required : false},
          {columnCode:"routingNumber", name: "Branch Code", required: true, errMsg: "Branch Code is required"},
          {columnCode: "accountType", uiVisible: false, required : false},
          { columnCode: "accountNumber", name : "Account Number" }
        ];
        paymentDetailsMY = EmployeeListService.getAlteredConfigDetails(paymentDetailsMY, alteredOptionsMY, false, {}, {});
        this.paymentInitials = (paymentDetailsMY);
        break;
      default:
        break;
    }
    this.buildForm()
  }
  buildForm = () => {
    this.putAdditionalFields().then(() => {

      if (this.isUSCountry) {
        let ifscCodeInd = this.paymentInitials.findIndex((res) => res.id == "ifsc");
        this.paymentInitials[ifscCodeInd].uiVisible = false;
        this.paymentInitials[ifscCodeInd].required = false;
      }
      this.paymentFormFields = this.paymentInitials.filter((x) => x.uiVisible);
      let employeePaymentFields = DataGridUtility.getPaymentFormElements(
        this.paymentFormFields,
        this.defaultValues,
        true,
        this.isInviteUserEnabled
      );
      
      this.paymentFormFields = employeePaymentFields;
      this.setState({
        ...this.state
      })
    });
  };
  putAdditionalFields = () => {
    this.updateFieldOptions();
    return Promise.resolve();
  };
  updateFieldOptions = () => {
    //Do not remove this message
  };
  updateColumConfigForPaymentMethod = (selectedOption, isInviteFlow) => {
    if (selectedOption && selectedOption.id === "cash") {
        const alteredConfig = [
          { columnCode: "accountType", required: false, uiVisible: false },
          { columnCode: "ifsc", uiVisible: false, required: false },
          { columnCode: "accountNumber", uiVisible: false, required: false },
          { columnCode: "routingNumber", required: false, uiVisible: false },
          { columnCode: "upiId", required: false, uiVisible: false },
          { columnCode: "bank", required: false, uiVisible: false },
        ];
        const updatedOptions = {
          accountType: [],
          ifsc: "",
          accountNumber: "",
          routingNumber: "",
          upiId: "",
          bank: ""
        };
        if (Utility.isEmpty(this.defaultValues["paymentMethod"]) && !isInviteFlow) {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
        } else {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
        }
        EmployeeListService.getAlteredConfigDetails(
          this.paymentInitials,
          alteredConfig,
          true,
          this.defaultValues,
          updatedOptions
        );
      } else if (selectedOption && selectedOption.id === "cheque") {
        const alteredConfig = [
          { columnCode: "accountType", required: false, uiVisible: false },
          {
            columnCode: "accountNumber",
            uiVisible: true,
            required: false,
            name: "Employee Bank Account Number",
          },
          { columnCode: "routingNumber", required: false, uiVisible: false },
          { columnCode: "upiId", required: false, uiVisible: false },
          { columnCode: "bank", required: false, uiVisible: false },
        ];
        const updatedOptions = {
          accountType: [],
          routingNumber: "",
          upiId: "",
          bank: "",
        };
        if (Utility.isEmpty(this.defaultValues["paymentMethod"]) && !isInviteFlow) {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
        } else {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
        }
        switch(this.country) {
          case "IN":
            alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible:false });
            updatedOptions["ifsc"] = "";
            break;
        }
        EmployeeListService.getAlteredConfigDetails(
          this.paymentInitials,
          alteredConfig,
          true,
          this.defaultValues,
          updatedOptions
        );
      } else if (selectedOption && selectedOption.id === "upi") {
        const alteredOptions = [
          { columnCode: "accountType", required: false, uiVisible: false },
          { columnCode: "ifsc", required: false, uiVisible: false },
          { columnCode: "accountNumber", uiVisible: false, required: false},
          { columnCode: "routingNumber", required: false, uiVisible: false },
          { columnCode: "upiId", required: true, uiVisible: true, name: "UPI ID"},
          { columnCode: "bank", required: false, uiVisible: false },
        ];
        const updatedOptions = {
          accountType: [],
          ifsc:"",
          accountNumber:"",
          routingNumber: "",
          bank: "",
        };
        if (Utility.isEmpty(this.defaultValues["paymentMethod"]) && !isInviteFlow) {
          alteredOptions.push({ columnCode: "paymentMethod", hasError: true });
        } else {
          alteredOptions.push({ columnCode: "paymentMethod", hasError: false });
        }
        EmployeeListService.getAlteredConfigDetails(
          this.paymentInitials,
          alteredOptions,
          true,
          this.defaultValues,
          updatedOptions
        );
      } else {
        const updatedOptions = {
          upiId:""
        };
        const alteredConfig = [
          { columnCode: "upiId", required: false,uiVisible: false,name: "UPI ID"}
        ];
        switch(this.country) {
          case COUNTRY.US:
            alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
            alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
            alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
            alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
            alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
            break;
          case COUNTRY.SG:
            alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
            alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
            alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
            alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
            alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
            break;
          case COUNTRY.MY:
            alteredConfig.push({ columnCode: "accountType", required: false, uiVisible: false });
            alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Account Number" });
            alteredConfig.push({ columnCode: "routingNumber", required: true, uiVisible: true, name: "Branch Code" });
            alteredConfig.push({ columnCode: "bank", required: true, uiVisible: true });
            alteredConfig.push({ columnCode: "ifsc", required: false, uiVisible: false });
            break;
          case COUNTRY.IN:
            alteredConfig.push({ columnCode: "accountType", required: true, uiVisible: true });
            alteredConfig.push({ columnCode: "accountNumber", uiVisible: true, required: true, name : "Employee Bank Account Number" });
            alteredConfig.push({ columnCode: "routingNumber", required: false, uiVisible: true });
            alteredConfig.push({ columnCode: "bank", required: false, uiVisible: false });
            alteredConfig.push({ columnCode: "ifsc", required: true, uiVisible: true, name: "IFSC Code" });
            break;
        }
        if (Utility.isEmpty(this.defaultValues["paymentMethod"]) && !isInviteFlow) {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: true });
        } else {
          alteredConfig.push({ columnCode: "paymentMethod", hasError: false });
          if(this.props.onPaymentMethodSelection) {
            this.props.onPaymentMethodSelection(this.defaultValues["paymentMethod"]);
          }
        }
        EmployeeListService.getAlteredConfigDetails(
          this.paymentInitials,
          alteredConfig,
          true,
          this.defaultValues,
          updatedOptions
        );
      }
    this.updatePaymentInitials()
    this.buildForm()

  };
  scrollToBottom = () => {
    setTimeout(() => {
      const holder = document.getElementById("dk-form-popup-window");
      if (holder) {
        holder.scrollTop = holder.offsetHeight;
      }
    }, 10);
  };
  isValid() {
    let isValid = true;
    const invalidField = [];
    this.paymentFormFields.forEach(field => {
      if (field.hasError || (field.required && Utility.isEmpty(this.defaultValues[field.columnCode]))) {
        field['hasError'] = true
        isValid = false;
        invalidField.push(field.id);
      } else {
        field['hasError'] = false
      }

    })
    if(invalidField.length > 0) {
        scrollToError(invalidField[0]);
    }
    return isValid
  }
  prepareForSubmit() {
    const paymentMethod = EmployeeListService.getSelectedIdFromObject(
        this.defaultValues['paymentMethod'],
        "id"
      );
    let paymentDetails = {
      accountNumber: !Utility.isEmpty(this.defaultValues['accountNumber']) ? this.defaultValues['accountNumber']: "",
      accountType: !Utility.isEmpty(this.defaultValues['accountType']) ? this.defaultValues['accountType'].id : "",
      ifsc: !Utility.isEmpty(this.defaultValues['ifsc']) ? this.defaultValues['ifsc']:"",
      paymentMethod: !Utility.isEmpty(this.defaultValues['paymentMethod']) ? this.defaultValues['paymentMethod'].id:"",
      routingNumber: !Utility.isEmpty(this.defaultValues['routingNumber']) ? this.defaultValues['routingNumber'] :"",
      upi: !Utility.isEmpty(this.defaultValues['upiId']) ? this.defaultValues['upiId'] :""
    }
    if((getTenantCountryCode() === COUNTRY.SG || getTenantCountryCode() === COUNTRY.MY) && paymentMethod === "directDeposit") {
        paymentDetails["bank"] = EmployeeListService.getSelectedIdFromObject(this.defaultValues.bank, "key");
        paymentDetails["bankId"] = EmployeeListService.getSelectedIdFromObject(this.defaultValues.bank, "id");
        paymentDetails["accountType"] = EmployeeListService.getSelectedIdFromObject(this.defaultValues.bank, "id");
      }
    return paymentDetails;
  }
  save() {
    if (!this.isValid()) {
      this.setState({
        ...this.state
      })
      return
    }
    let paymentObject = this.prepareForSubmit();
    if (!paymentObject) {
      showToast(i18next.t("INVALID_FIELD"), TOAST_TYPE.FAILURE);
      return
    }
    try {
      
      showLoader(i18next.t("UPDATE_PAYROLL"));
      Table.upatePayroll({ ...this.props.data, ...paymentObject }, this.props.payrunId).then((data) => {
        showToast(i18next.t("REC_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS);
        removeLoader()
        this.close(true)

      })
    } catch (err) {
      removeLoader()
      showToast(i18next.t("ERROR_UPDATE_PAYROLL"), TOAST_TYPE.FAILURE);
    }
  }
  getPaymentDetailFormData() {
    if (!this.isValid()) {
      this.setState({
        ...this.state
      })
      return
    }
    return this.prepareForSubmit()
  }
  getPaymentFormFields = () => {
    return this.paymentFormFields.map((obj, index) => {
      return (
        <div
          className={`column padding-bottom-mobile ${!this.props.fieldOnly ?"p-h-s web-width-50 mb-m":"parent-width mb-l"} ${obj.id} ${(obj.id ==='ifsc' && obj.hasError) ?"mb-xxl":"" }`}
          key={obj.id}
        >
          <DKInput
            title={obj.name}
            placeholder={obj.name}
            value={this.defaultValues ? this.defaultValues[obj.id] : ""}
            formatter={(obj) => {
              /** How to render a selected option in case of object **/
              return obj.name;
            }}
            options={obj.options}
            type={obj.type}
            labelClassName=" text-align-left "
            onChange={(value) => {
              this.onChange(value, index, obj, obj.name);
            }}
            direction={obj.direction}
            required={obj.required}
            readOnly={obj.readOnly || !PermissionUtils.hasAccess(MODULE.PAYRUN, [ACTION.SUBMIT])}
            onClick={() => {
              
            }}
            dropdownConfig={{
              className: "",
              style: {},
              allowSearch: obj.options && obj.options.length > 6 ? true : false,
              searchableKey: "name",
              data: obj.options,
              renderer: (index, obj) => {
                /** How to render value in Dropdown in case of object **/
                return <DKLabel text={`${obj.name}`} />;
              },
              onSelect: (index, obj) => {
                // onValueChange(obj, "Quarter");
              },
            }}
            canValidate={obj.hasError}
            validator={(value) => {
              return !obj.hasError;
            }}
            errorMessage={obj.errMsg}
          />
          {/* {obj.hasError && (
            <DKLabel
              className="pl-s fs-s unselectable text-red mt-r"

              text={obj.errMsg}
            />
          )} */}
        </div>
      );
    });
  };
  render() {
    return (
      <>
        {
          !this.props.fieldOnly && <Popup
            popupClass="payment-method-popup popup-overflow"
            onClose={() => this.close()}
          >
            <div className="row">
              <DKLabel text={i18next.t("PAYMENT_METHOD")} className=" fs-l fw-m parent-width" />
              <div className="row justify-content-end">
                <DKButton title={i18next.t("CANCEL")} className="bg-gray1 mr-r border-m" onClick={() => this.close()} />
                {PermissionUtils.hasAccess(MODULE.PAYRUN, [ACTION.SUBMIT]) && <DKButton title={i18next.t("SAVE")} className="bg-app text-white mr-r" onClick={() => this.save()} />}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
              className=" parent-width mb-s  pt-l"
            >
              {this.getPaymentFormFields()}
            </div>

          </Popup>
        }
        {
          this.props.fieldOnly && <>
            {this.getPaymentFormFields()}
          </>
        }
      </>
    )
  }
}

const mapStateToProps = (state ) => {
    return {tenatBankDetails: state.employee?.formData?.bankDetails || {}}
}

export default connect(mapStateToProps,null,null,{ forwardRef: true })(PaymentMethod);